export class TelemetryDashboardRequestError extends Error {}
